import { render, staticRenderFns } from "./GuaranteeOnboardingIdentityVerification.vue?vue&type=template&id=1a8de30e&scoped=true&"
import script from "./GuaranteeOnboardingIdentityVerification.vue?vue&type=script&lang=js&"
export * from "./GuaranteeOnboardingIdentityVerification.vue?vue&type=script&lang=js&"
import style0 from "./GuaranteeOnboardingIdentityVerification.vue?vue&type=style&index=0&id=1a8de30e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8de30e",
  null
  
)

export default component.exports